module.exports = __webpack_public_path__ + "static/img/home3.7208584.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/home3.jpg
// module id = pSJD
// module chunks = 0